module.exports = __webpack_public_path__ + "img/arrow-return-right.4fe7c006.svg";